module.exports = __webpack_public_path__ + "img/HG4301-163.747c049e.jpg";